import { create } from '@bufbuild/protobuf';

import {
  ConfirmReadChatMessagesRequest,
  ConfirmReadChatMessagesRequestSchema,
} from 'APP/wsApi/wsAppApi/types/chat/chat_requests_pb';
import { ConfirmReadChatMessagesResponse } from 'APP/wsApi/wsAppApi/types/chat/chat_responses_pb';

import { wsAppRequestManager } from '../WsAppApi';
import {
  DeleteMessagesRequest,
  DeleteMessagesRequestSchema,
  ForwardMessagesRequest,
  ForwardMessagesRequestSchema,
  type GetMessagesAroundTsRequest,
  GetMessagesAroundTsRequestSchema,
  GetMessagesByIdsRequest,
  GetMessagesByIdsRequestSchema,
  GetMessagesByMediaTypesRequest,
  GetMessagesByMediaTypesRequestSchema,
  GetMessagesRequest,
  GetMessagesRequestSchema,
  GetRangeAroundMessageRequest,
  GetRangeAroundMessageRequestSchema,
  GetRangeAroundNextUserMentionRequest,
  GetRangeAroundNextUserMentionRequestSchema,
  SendMessageRequest,
  SendMessageRequestSchema,
  UpdateMessageRequest,
  UpdateMessageRequestSchema,
  GetLinkPreviewRequest,
  GetLinkPreviewRequestSchema,
  GetUsersViewedMessageRequest,
  GetUsersViewedMessageRequestSchema,
  AddMessageReactionRequest,
  AddMessageReactionRequestSchema,
  RemoveMessageReactionRequest,
  RemoveMessageReactionRequestSchema,
  GetMessagesCountsRequest,
  GetMessagesCountsRequestSchema,
  GetScheduledMessagesRequest,
  GetScheduledMessagesRequestSchema,
  GetScheduledMessagesByIdsRequest,
  GetScheduledMessagesByIdsRequestSchema,
  DeleteScheduledMessagesRequest,
  DeleteScheduledMessagesRequestSchema,
  UpdateScheduledMessageRequest,
  UpdateScheduledMessageRequestSchema,
  ScheduleMessageRequest,
  ScheduleMessageRequestSchema,
  SendScheduledMessageNowRequest,
  SendScheduledMessageNowRequestSchema,
} from '../types/message/message_requests_pb';
import {
  DeleteMessagesResponse,
  ForwardMessagesResponse,
  GetMessagesAroundTsResponse,
  GetMessagesByIdsResponse,
  GetMessagesByMediaTypesResponse,
  GetMessagesResponse,
  GetRangeAroundMessageResponse,
  GetRangeAroundNextUserMentionResponse,
  SendMessageResponse,
  UpdateMessageResponse,
  GetLinkPreviewResponse,
  GetUsersViewedMessageResponse,
  AddMessageReactionResponse,
  RemoveMessageReactionResponse,
  GetMessagesCountsResponse,
  GetScheduledMessagesResponse,
  GetScheduledMessagesByIdsResponse,
  DeleteScheduledMessagesResponse,
  UpdateScheduledMessageResponse,
  ScheduleMessageResponse,
  SendScheduledMessageNowResponse,
} from '../types/message/message_responses_pb';
import {
  RealtimeSubscribeOnMessagesUpdateRequest,
  RealtimeSubscribeOnMessagesUpdateRequestSchema,
} from '../types/realtime_event/realtime_event_requests_pb';
import { RealtimeSubscribeOnMessagesUpdateResponse } from '../types/realtime_event/realtime_event_responses_pb';
import { WsRequest } from './request.types';

export function getMessagesByMediaTypesRequest(
  data: WsRequest<GetMessagesByMediaTypesRequest>
): Promise<GetMessagesByMediaTypesResponse> {
  return wsAppRequestManager.request<GetMessagesByMediaTypesResponse>({
    case: 'getMessagesByMediaTypes',
    value: create(GetMessagesByMediaTypesRequestSchema, data),
  });
}

export function sendMessageRequest(
  data: WsRequest<SendMessageRequest>
): Promise<SendMessageResponse> {
  return wsAppRequestManager.request<SendMessageResponse>({
    case: 'sendMessage',
    value: create(SendMessageRequestSchema, data),
  });
}

export function updateMessageRequest(
  data: WsRequest<UpdateMessageRequest>
): Promise<UpdateMessageResponse> {
  return wsAppRequestManager.request<UpdateMessageResponse>({
    case: 'updateMessage',
    value: create(UpdateMessageRequestSchema, data),
  });
}

export function getMessagesByIdsRequest(
  data: WsRequest<GetMessagesByIdsRequest>
): Promise<GetMessagesByIdsResponse> {
  return wsAppRequestManager.request<GetMessagesByIdsResponse>({
    case: 'getMessagesByIds',
    value: create(GetMessagesByIdsRequestSchema, data),
  });
}

export function getMessagesRequest(
  data: WsRequest<GetMessagesRequest>
): Promise<GetMessagesResponse> {
  return wsAppRequestManager.request<GetMessagesResponse>({
    case: 'getMessages',
    value: create(GetMessagesRequestSchema, data),
  });
}

export function getRangeAroundMessageRequest(
  data: WsRequest<GetRangeAroundMessageRequest>
): Promise<GetRangeAroundMessageResponse> {
  return wsAppRequestManager.request<GetRangeAroundMessageResponse>({
    case: 'getRangeAroundMessage',
    value: create(GetRangeAroundMessageRequestSchema, data),
  });
}

export function subscribeOnMessages(
  data: WsRequest<RealtimeSubscribeOnMessagesUpdateRequest>
): Promise<RealtimeSubscribeOnMessagesUpdateResponse> {
  return wsAppRequestManager.request<RealtimeSubscribeOnMessagesUpdateResponse>({
    case: 'subscribeOnMessages',
    value: create(RealtimeSubscribeOnMessagesUpdateRequestSchema, data),
  });
}

export function forwardMessagesRequest(
  data: WsRequest<ForwardMessagesRequest>
): Promise<ForwardMessagesResponse> {
  return wsAppRequestManager.request<ForwardMessagesResponse>({
    case: 'forwardMessages',
    value: create(ForwardMessagesRequestSchema, data),
  });
}

export function deleteMessagesRequest(
  data: WsRequest<DeleteMessagesRequest>
): Promise<DeleteMessagesResponse> {
  return wsAppRequestManager.request<DeleteMessagesResponse>({
    case: 'deleteMessages',
    value: create(DeleteMessagesRequestSchema, data),
  });
}

export function confirmReadChatMessagesRequest(
  data: WsRequest<ConfirmReadChatMessagesRequest>
): Promise<ConfirmReadChatMessagesResponse> {
  return wsAppRequestManager.request<ConfirmReadChatMessagesResponse>({
    case: 'confirmReadChatMessages',
    value: create(ConfirmReadChatMessagesRequestSchema, data),
  });
}

export function getRangeAroundNextUserMentionRequest(
  data: WsRequest<GetRangeAroundNextUserMentionRequest>
): Promise<GetRangeAroundNextUserMentionResponse> {
  return wsAppRequestManager.request<GetRangeAroundNextUserMentionResponse>({
    case: 'getRangeAroundNextUserMention',
    value: create(GetRangeAroundNextUserMentionRequestSchema, data),
  });
}

export function getRangeMessageByTsRequest(
  data: WsRequest<GetMessagesAroundTsRequest>
): Promise<GetMessagesAroundTsResponse> {
  return wsAppRequestManager.request<GetMessagesAroundTsResponse>({
    case: 'getRangeMessageByTs',
    value: create(GetMessagesAroundTsRequestSchema, data),
  });
}

export function getLinkPreviewRequest(
  data: WsRequest<GetLinkPreviewRequest>
): Promise<GetLinkPreviewResponse> {
  return wsAppRequestManager.request<GetLinkPreviewResponse>({
    case: 'getLinkPreview',
    value: create(GetLinkPreviewRequestSchema, data),
  });
}

export function getUsersViewedMessageRequest(
  data: WsRequest<GetUsersViewedMessageRequest>
): Promise<GetUsersViewedMessageResponse> {
  return wsAppRequestManager.request<GetUsersViewedMessageResponse>({
    case: 'getUsersViewedMessage',
    value: create(GetUsersViewedMessageRequestSchema, data),
  });
}

export function addMessageReactionRequest(
  data: WsRequest<AddMessageReactionRequest>
): Promise<AddMessageReactionResponse> {
  return wsAppRequestManager.request<AddMessageReactionResponse>({
    case: 'addMessageReaction',
    value: create(AddMessageReactionRequestSchema, data),
  });
}

export function removeMessageReactionRequest(
  data: WsRequest<RemoveMessageReactionRequest>
): Promise<RemoveMessageReactionResponse> {
  return wsAppRequestManager.request<RemoveMessageReactionResponse>({
    case: 'removeMessageReaction',
    value: create(RemoveMessageReactionRequestSchema, data),
  });
}

export function getMessagesCountsRequest(
  data: WsRequest<GetMessagesCountsRequest>
): Promise<GetMessagesCountsResponse> {
  return wsAppRequestManager.request<GetMessagesCountsResponse>({
    case: 'getMessagesCounts',
    value: create(GetMessagesCountsRequestSchema, data),
  });
}

export function getScheduledMessagesRequest(
  data: WsRequest<GetScheduledMessagesRequest>
): Promise<GetScheduledMessagesResponse> {
  return wsAppRequestManager.request<GetScheduledMessagesResponse>({
    case: 'getScheduledMessages',
    value: create(GetScheduledMessagesRequestSchema, data),
  });
}

export function getScheduledMessagesByIdsRequest(
  data: WsRequest<GetScheduledMessagesByIdsRequest>
): Promise<GetScheduledMessagesByIdsResponse> {
  return wsAppRequestManager.request<GetScheduledMessagesByIdsResponse>({
    case: 'getScheduledMessagesByIds',
    value: create(GetScheduledMessagesByIdsRequestSchema, data),
  });
}

export function deleteScheduledMessagesRequest(
  data: WsRequest<DeleteScheduledMessagesRequest>
): Promise<DeleteScheduledMessagesResponse> {
  return wsAppRequestManager.request<DeleteScheduledMessagesResponse>({
    case: 'deleteScheduledMessages',
    value: create(DeleteScheduledMessagesRequestSchema, data),
  });
}

export function updateScheduledMessageRequest(
  data: WsRequest<UpdateScheduledMessageRequest>
): Promise<UpdateScheduledMessageResponse> {
  return wsAppRequestManager.request<UpdateScheduledMessageResponse>({
    case: 'updateScheduledMessage',
    value: create(UpdateScheduledMessageRequestSchema, data),
  });
}

export function scheduleMessageRequest(
  data: WsRequest<ScheduleMessageRequest>
): Promise<ScheduleMessageResponse> {
  return wsAppRequestManager.request<ScheduleMessageResponse>({
    case: 'scheduleMessage',
    value: create(ScheduleMessageRequestSchema, data),
  });
}

export function sendScheduledMessageNowRequest(
  data: WsRequest<SendScheduledMessageNowRequest>
): Promise<SendScheduledMessageNowResponse> {
  return wsAppRequestManager.request<SendScheduledMessageNowResponse>({
    case: 'sendScheduledMessageNow',
    value: create(SendScheduledMessageNowRequestSchema, data),
  });
}
